import Box from '@eversports/klimt-primitives/legacy/Box'
import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import type { CorporateBenefits } from '../../../App.types'
import { useIntl } from '../../../localization/react'
import CorporatePlaceholderLogo from '../assets/corporate-placeholder.webp'
import { ColorContrast } from '../Header.types'
import { UserProfileRoutes } from '../UserMenu/UserMenu.constants'

import CorporateBenefitLabel from './CorporateBenefitsLabel'

interface Props {
  corporateBenefits?: CorporateBenefits | null
  colorContrast?: ColorContrast
}

const CorporateBenefits = ({ corporateBenefits, colorContrast = ColorContrast.NORMAL }: Props) => {
  const intl = useIntl()

  if (!corporateBenefits) return null

  const { corporatePartner, availableBudget, hasSpecialPriceAccess } = corporateBenefits

  if (!availableBudget && !hasSpecialPriceAccess) return null

  return (
    <Link to={UserProfileRoutes.MY_CORPORATE_BENEFITS} external ariaLabel={intl.corporateBenefitsAriaLabel()}>
      <Stack
        direction="row"
        gap={2}
        alignItems="center"
        sx={{
          px: 0,
          py: { xs: 4, lg: 0 },
          flexShrink: 0,
          '&:hover': { backgroundColor: { xs: 'lightgray', lg: 'transparent' } },
        }}
      >
        <Box
          sx={{
            borderRadius: 10,
            border: '1px solid',
            borderColor: 'lightgray',
            overflow: 'hidden',
          }}
        >
          <Box
            component="img"
            src={corporatePartner.logo?.xSmall ?? CorporatePlaceholderLogo}
            alt={`${corporatePartner.name} logo`}
            loading="lazy"
            width={{ xs: '16px', lg: '20px' }}
            height={{ xs: '16px', lg: '20px' }}
          />
        </Box>
        <CorporateBenefitLabel
          availableBudget={availableBudget}
          corporatePartnerName={corporatePartner.name}
          colorContrast={colorContrast}
        />
      </Stack>
    </Link>
  )
}

export default CorporateBenefits
